























import {
  defineComponent,
  PropType,
  computed,
  ref,
  onMounted,
} from '@vue/composition-api';
import { NoticeBar } from '@hb/coffee';
import { CloseOutline12, WarningOutline16 } from '@hb/coffee-icons';
import { UserCreditData } from '@/pages/home/types';
import { PocketMoneyStatusEnum } from '@/api/homeV2Status/types';
import { local } from '@/shared/utils/storage';
import store from '@/store';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import { TP_HOME_MESSAGE_NOTICE_BAR_EXPOSE, TP_HOME_MESSAGE_NOTICE_BAR_CLOSE } from '@/pages/home/tianqi';
import { messageConfigList } from './config';

export default defineComponent({
  name: 'MessageNoticeBar',
  components: {
    NoticeBar,
    CloseOutline12,
    WarningOutline16,
  },
  props: {
    userCreditData: {
      type: Object as PropType<UserCreditData>,
      required: true,
    },
    className: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    /** 已关闭过消息提示 */
    const hasClose = ref(false);

    const userId = computed(() => store.state.base.userId);

    const getCloseCountKey = (name: string) => `closeCountMessageNoticeBar_${userId.value}_${name}`;
    const getExposeCountKey = (name: string) => `exposeCountMessageNoticeBar_${userId.value}_${name}`;

    /** 当前消息提示配置 */
    const curMessageConfig = computed(() => messageConfigList.find((item) => {
      const closeCount = local.get(getCloseCountKey(item.name));
      const exposeCount = local.get(getExposeCountKey(item.name));
      /** 关闭次数小于最大关闭次数，曝光次数小于最大曝光次数，且满足展示条件 */
      return Number(closeCount) < item.closeMaxCount
        && Number(exposeCount) <= item.exposeMaxCount
        && item.isShow(props.userCreditData);
    }));

    /** 当前展示的消息提示名称 */
    const curName = computed(() => curMessageConfig.value?.name);
    /** 消息提示文案 */
    const noticeText = computed(() => curMessageConfig.value?.noticeText);
    /** 是否展示消息提示 */
    const isShow = computed(() => curMessageConfig.value && !hasClose.value);

    onMounted(() => {
      /** 曝光次数 */
      if (isShow.value && curName.value) {
        const exposeCount = Number(local.get(getExposeCountKey(curName.value))) + 1;
        local.set(getExposeCountKey(curName.value), exposeCount);
        ubtSetupModuleExpose(TP_HOME_MESSAGE_NOTICE_BAR_EXPOSE, {
          type: curName.value,
          count: exposeCount,
        });
      }
    });

    /** 关闭消息提示 */
    const onClose = () => {
      if (curName.value) {
        const closeCount = Number(local.get(getCloseCountKey(curName.value))) + 1;
        local.set(getCloseCountKey(curName.value), closeCount);
        ubtSetupPageButton(TP_HOME_MESSAGE_NOTICE_BAR_CLOSE, {
          type: curName.value,
          count: closeCount,
        });
      }
      hasClose.value = true;
    };

    return {
      noticeText,
      PocketMoneyStatusEnum,
      onClose,
      isShow,
    };
  },
});
